import { AsyncState, loadingAsyncState } from 'widgets-for-react'
import { filtersApi } from './filtersLoaderApi'

export type FiltersLoaderState = AsyncState<FiltersData>

export type FiltersData = {
  MainCategories: MainCategory[]
  Techniques: Filter[]
  Appearances: Filter[]
  Textures: Filter[]
  Allergens: Filter[]
}

export type MainCategory = Filter & {
  Subcategories: Subcategory[]
}

export type Subcategory = Filter & {
  Ingredients: Filter[]
}

export type Filter = {
  Translation: string
  Title: string
}

export const initialFiltersLoaderState: FiltersLoaderState =
  loadingAsyncState(filtersApi)
